import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import CreatorGrowthEngine from '@/pages/new-app/CreatorGrowthEngine';

/** Growth Intelligence tile dialog — the existing Creator Growth Engine,
 * reused as-is via its "intelligence" render mode (every section except
 * Rewards Progress, which lives exclusively in Milestones & Rewards so
 * official reward tracking isn't duplicated). No sample data changed. */
export default function GrowthIntelligenceDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#14171F] border-white/10 text-white sm:max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="growth-intelligence-dialog">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            Growth Intelligence
            <Badge variant="outline" className="text-[10px] border-cyan-500/30 text-cyan-300 bg-cyan-500/10 uppercase tracking-wider">Growth OS</Badge>
          </DialogTitle>
        </DialogHeader>
        <CreatorGrowthEngine mode="intelligence" />
      </DialogContent>
    </Dialog>
  );
}
